// extracted by mini-css-extract-plugin
export default {"root":"_1vys6","header":"_29eEy"};